module.exports = __webpack_public_path__ + "static/media/logo-new.ea764a58.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo-new.svg
// module id = 623
// module chunks = 0